import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import Button from "@mui/material/Button";
import { Modal } from "react-bootstrap";
import RegisterManufacturer from "./RegisterManufacturer";
import LoadingButton from "@mui/lab/LoadingButton";
import { getIdCompany } from "../../utils/constantes";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import blogFetch from "../../axios/config";
import Context from "../../context/Context";
import language from "../../nls/language.json";
import "../../styles/Style.css";
import { IManufacturer } from "./manufacturerInferfaces";

function Manufacturer() {
  const [manufacturers, setManufacturers] = useState<IManufacturer[]>();
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [manufacturerId, setManufacturerId] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  const ref:any = React.useRef();

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getManufacturers();
  }, []);

  const getManufacturers = async () => {
    try {
      let response = await blogFetch.get(
        `/manufacturer?companyId=${getIdCompany()}`
      );
      let data = response.data;
      setManufacturers(data);
    } catch (error) {
      console.error(error);
    }
  };


  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterManufacturer ref={ref}></RegisterManufacturer>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalAdd(false)}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.modal.adicionar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.addManufacturer();
                setLoading(false);
                setShowModalAdd(false);
                getManufacturers();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.modal.adicionar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalEdit = () => {
    return (
      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.modal.editar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterManufacturer
            ref={ref}
            idManufacturer={manufacturerId}
          ></RegisterManufacturer>
        </Modal.Body>{" "}
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalAdd(false)}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.modal.editar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.updateManufacturer();
                setShowModalEdit(false);
                setLoading(false);
                getManufacturers();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.modal.editar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.title}
            </h3>
          </div>
          <div>
            <Button
              className="add_button"
              variant="contained"
              onClick={() => {
                setShowModalAdd(true);
              }}
            >
              {(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.btnAdicionar}
            </Button>
          </div>
        </div>
        <table className="table table-hover">
          <thead className="table-header header-tables">
            <tr className="table_row">
              <th>#</th>
              <th>{(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.tableHeader.descricao}</th>
              <th>{(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.tableHeader.cnpj}</th>
              <th>{(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.tableHeader.telefone}</th>
              <th className="edit">{(language as Record<string, any>)[selectedCountry.name].Cadastro.fabricante.tableHeader.editar}</th>
            </tr>
          </thead>
          <tbody className="table_row">
            {!!manufacturers &&
              Object.entries(manufacturers).map((item) => (
                <tr key={item[1].mfC_PK_idManufacturer}>
                  <td>{item[1].mfC_PK_idManufacturer}</td>
                  <td>{item[1].mfC_name}</td>
                  <td>{item[1].mfC_cnpj}</td>
                  <td>{item[1].mfC_phone}</td>
                  <td className="edit">
                    <center>
                      <ModeEditIcon
                        onClick={() => {
                          setManufacturerId(item[1].mfC_PK_idManufacturer);
                          setShowModalEdit(true);
                        }}
                      />
                    </center>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {modalAdd()}
      {modalEdit()}
    </>
  );
}

export default Manufacturer;
